export interface SkipLinkTarget {
  id: string
  href: string
  labelKey: string
}

export const SKIP_LINK_TARGETS: SkipLinkTarget[] = [
  {
    id: 'main-content',
    href: '#main-content',
    labelKey: 'skip_link_main_content',
  },
  {
    id: 'navigation',
    href: '#navigation',
    labelKey: 'skip_link_navigation',
  },
  {
    id: 'footer',
    href: '#footer',
    labelKey: 'skip_link_footer',
  },
]

export function resolveSkipLinkTarget(id: string): HTMLElement | null {
  return document.getElementById(id)
}

const NATIVELY_FOCUSABLE_TAG_NAMES = new Set(['A', 'AREA', 'BUTTON', 'INPUT', 'SELECT', 'TEXTAREA', 'IFRAME'])

function isNativelyFocusable(target: HTMLElement): boolean {
  return target.hasAttribute('tabindex') || NATIVELY_FOCUSABLE_TAG_NAMES.has(target.tagName)
}

export function focusSkipLinkTarget(target: HTMLElement): void {
  const needsTemporaryTabIndex = !isNativelyFocusable(target)

  if (needsTemporaryTabIndex) {
    target.setAttribute('tabindex', '-1')
    target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true })
  }

  target.focus({ preventScroll: false })
  target.scrollIntoView()
}
